import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var Seguimiento_cert_Service = /** @class */ (function () {
    function Seguimiento_cert_Service(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    Seguimiento_cert_Service.prototype.getSolicitudes = function (rut) {
        console.log('3');
        var params = {
            rut: rut
        };
        console.log('4');
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        console.log('5');
        return this._http.post(this.url + 'seguimiento_solicitudes', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    Seguimiento_cert_Service.prototype.getCert = function (rut, numero) {
        console.log('a');
        var params = {
            rut: rut,
            num_solicitud: numero
        };
        console.log('b');
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        console.log('c');
        return this._http.post(this.url + 'seguimiento_certificado', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    Seguimiento_cert_Service.prototype.getSolicitud = function (id) {
        var params = {
            id: id
        };
        var headers = new Headers({
            'Content-type': 'application/json',
        });
        return this._http.post(this.url + 'seguimiento_solicitudes', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return Seguimiento_cert_Service;
}());
export { Seguimiento_cert_Service };
